import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { Button } from '@/components/buttons';
import { Modals } from '@/helpers/modals';
import { useModalsStore } from '@/store';
import { pulseShadow3 } from '@/styles/keyframes';
import { ScAuthButtons } from './styled';

interface AuthButtonsProps {
  fullSizeAddons: boolean;
}

export const AuthButtons: FC<AuthButtonsProps> = ({ fullSizeAddons }) => {
  const { t } = useTranslation('common');
  const { mainColor } = useTheme();
  const open = useModalsStore.use.open();

  const handleRegisterClick = () => {
    open(Modals.Registration);
  };

  const handleLoginClick = () => {
    open(Modals.Login);
  };

  return (
    <ScAuthButtons fullyVisible={fullSizeAddons}>
      <div className="buttonWrap">
        <Button onClick={handleLoginClick} secondary small>
          {t('button.login')}
        </Button>
      </div>
      <div className="or">{t('modals.authorization.or')}</div>
      <div className="buttonWrap">
        <Button
          animation={{ keyframes: pulseShadow3(mainColor), duration: 1.5 }}
          onClick={handleRegisterClick}
          primary
          small
        >
          {t('button.signUp')}
        </Button>
      </div>
    </ScAuthButtons>
  );
};
